import React from 'react';
import './Blogs.css';
import { blogsData } from './BlogsData';
import { Link } from 'react-router-dom';

const Blogs = () => (
  <div className="blogs-container">
    {blogsData.map(blog => (
      <div className="blog-card" key={blog.id}>
        <div className="blog-date">{blog.date}</div>
        <h2 className="blog-heading">{blog.title}</h2>
        <h4 className="blog-subheading">{blog.subHeading}</h4>
        <div className="blog-labels">
          {blog.labels.map(label => (
            <span className="blog-label" key={label}>{label}</span>
          ))}
        </div>
        <div className="blog-body">{blog.summary}</div>
        <Link
          to={`/blog/${blog.id}`}
          className="read-full-link"
        >
          Read Full Blog
        </Link>
      </div>
    ))}
  </div>
);

export default Blogs;
